import React, { useState } from 'react';
import BioEditor from './BioEditor';
import ResumeEditor from './ResumeEditor';
import './Admin.css';

const Admin = () => {
    const [selectedTab, setSelectedTab] = useState('Bio');

    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    };

    return (
        <div className="admin-container">
            <div className="tab-slider">
                <button
                    className={`tab-btn ${selectedTab === 'Bio' ? 'active' : ''}`}
                    onClick={() => handleTabChange('Bio')}
                >
                    Bio Editor
                </button>
                <button
                    className={`tab-btn ${selectedTab === 'Resume' ? 'active' : ''}`}
                    onClick={() => handleTabChange('Resume')}
                >
                    Resume Editor
                </button>
            </div>

            <div className="editor-content">
                {selectedTab === 'Bio' ? <BioEditor /> : <ResumeEditor />}
            </div>
        </div>
    );
};

export default Admin;
